// extracted by css-extract-rspack-plugin
export default {"wikiIcon":"VfCMPW"};